import { NotificationActions } from './actions';
import {
    FETCH_NOTIFICATION_FAILURE,
    FETCH_NOTIFICATION_REQUEST,
    FETCH_NOTIFICATION_SUCCESS,
    PUSH_LIST_NOTIFICATION,
    SET_NOTIFICATION_FAILURE,
    SET_NOTIFICATION_REQUEST,
    SET_NOTIFICATION_SUCCESS,
    TOGGLE_NOTIFICATION_FAILURE,
    TOGGLE_NOTIFICATION_REQUEST,
    TOGGLE_NOTIFICATION_SUCCESS,
    UPDATE_LIST_NOTIFICATION,
} from './constants';
import { NotificationData, PriceNotificationsData } from './types';

export interface NotificationState {
    loading: boolean;
    toggleLoading: boolean;
    setPriceNotificationLoading: boolean;
    priceNotificationLoading: boolean;
    priceNotifications: PriceNotificationsData[];
    notifications: NotificationData[];
    error: any;
}

export const initialNotificationState: NotificationState = {
    loading: false,
    toggleLoading: false,
    setPriceNotificationLoading: false,
    priceNotificationLoading: false,
    priceNotifications: [],
    notifications: [],
    error: null,
};

export const notificationsReducer = (
    state: NotificationState = initialNotificationState,
    action: NotificationActions,
): NotificationState => {
    switch (action.type) {
        case FETCH_NOTIFICATION_REQUEST:
            return { ...state, loading: true };

        case FETCH_NOTIFICATION_SUCCESS:
            return { ...state, loading: false, notifications: action.payload };

        case FETCH_NOTIFICATION_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case TOGGLE_NOTIFICATION_REQUEST:
            return { ...state, toggleLoading: true };

        case TOGGLE_NOTIFICATION_SUCCESS:
            return { ...state, toggleLoading: false };

        case TOGGLE_NOTIFICATION_FAILURE:
            return { ...state, toggleLoading: false };

        case UPDATE_LIST_NOTIFICATION: {
            const newList: NotificationData[] = state.notifications.map((notification) => {
                if (notification.id === action.payload) return { ...notification, status: 1 };
                return notification;
            });
            return { ...state, notifications: newList };
        }

        case PUSH_LIST_NOTIFICATION: {
            return { ...state, notifications: [action.payload, ...state.notifications] };
        }

        case SET_NOTIFICATION_REQUEST: {
            return { ...state, setPriceNotificationLoading: true };
        }

        case SET_NOTIFICATION_SUCCESS: {
            return { ...state, setPriceNotificationLoading: false };
        }

        case SET_NOTIFICATION_FAILURE: {
            return { ...state, setPriceNotificationLoading: false };
        }

        default:
            return state;
    }
};
